import React from 'react'

export const Icon1 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <g clip-path="url(#clip0_9877_483)">
      <path
        d="M21.5 12C21.5 7.57708 17.5882 4 12.5 4C7.41184 4 3.5 7.57708 3.5 12C3.5 12.3387 3.52294 12.6724 3.56759 13H4.5787C4.52677 12.6732 4.5 12.3393 4.5 12C4.5 8.15032 7.94515 5 12.5 5C17.0549 5 20.5 8.15032 20.5 12C20.5 12.9746 20.2737 13.9303 19.8394 14.8129C19.7904 14.9124 19.7759 15.0255 19.7983 15.1342L20.37 17.915L17.6238 17.5676L17.5359 17.5642C17.4483 17.5686 17.3629 17.596 17.2885 17.6443C15.9392 18.521 14.2931 19 12.5 19C12.1602 19 11.8265 18.9825 11.5 18.9484V19.9532C11.8276 19.9841 12.1612 20 12.5 20L12.8704 19.9938L13.237 19.9751C14.8171 19.8677 16.2844 19.4147 17.5459 18.6619L17.673 18.581L20.9371 18.996L21.0207 18.9998C21.3216 18.9883 21.553 18.7072 21.4898 18.3994L20.81 15.094L20.8799 14.9462C21.2877 14.0141 21.5 13.0162 21.5 12Z"
        fill="white"
      />
      <path
        d="M6.4903 15.4019C6.4435 15.1682 6.2383 15 6 15C5.7617 15 5.5565 15.1682 5.5097 15.4019L5.4019 15.9408C5.204 16.9304 4.4304 17.704 3.4408 17.9019L2.9019 18.0097C2.6682 18.0564 2.5 18.2617 2.5 18.5C2.5 18.7383 2.6682 18.9436 2.9019 18.9903L3.4408 19.0981C4.4304 19.296 5.204 20.0696 5.4019 21.0592L5.5097 21.5981C5.5565 21.8318 5.7617 22 6 22C6.2383 22 6.4435 21.8318 6.4903 21.5981L6.5981 21.0592C6.796 20.0696 7.5696 19.296 8.5592 19.0981L9.0981 18.9903C9.3318 18.9436 9.5 18.7383 9.5 18.5C9.5 18.2617 9.3318 18.0564 9.0981 18.0097L8.5592 17.9019C7.5696 17.704 6.796 16.9304 6.5981 15.9408L6.4903 15.4019ZM4.6685 18.5C5.2252 18.1863 5.6863 17.7252 6 17.1685C6.3137 17.7252 6.7748 18.1863 7.3315 18.5C6.7748 18.8137 6.3137 19.2748 6 19.8315C5.6863 19.2748 5.2252 18.8137 4.6685 18.5Z"
        fill="white"
      />
      <path
        d="M9.5 11C10.0523 11 10.5 11.4477 10.5 12C10.5 12.5523 10.0523 13 9.5 13C8.94772 13 8.5 12.5523 8.5 12C8.5 11.4477 8.94772 11 9.5 11Z"
        fill="white"
      />
      <path
        d="M13.5 12C13.5 11.4477 13.0523 11 12.5 11C11.9477 11 11.5 11.4477 11.5 12C11.5 12.5523 11.9477 13 12.5 13C13.0523 13 13.5 12.5523 13.5 12Z"
        fill="white"
      />
      <path
        d="M16.5 12C16.5 11.4477 16.0523 11 15.5 11C14.9477 11 14.5 11.4477 14.5 12C14.5 12.5523 14.9477 13 15.5 13C16.0523 13 16.5 12.5523 16.5 12Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9877_483">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export const Icon2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M11.5 18H4.5V17H11.5V18Z" fill="white" />
    <path d="M7.5 15H4.5V14H7.5V15Z" fill="white" />
    <path d="M9.5 12H4.5V11H9.5V12Z" fill="white" />
    <path d="M12.5 9H4.5V8H12.5V9Z" fill="white" />
    <path d="M18.5 6H4.5V5H18.5V6Z" fill="white" />
    <path
      d="M16 8C16.2383 8 16.4435 8.16863 16.4902 8.40234L16.9316 10.6074C17.1296 11.5971 17.9029 12.3704 18.8926 12.5684L21.0977 13.0098L21.1826 13.0342C21.3713 13.1081 21.5 13.2915 21.5 13.5C21.5 13.7383 21.3314 13.9435 21.0977 13.9902L18.8926 14.4316C17.9647 14.6172 17.2272 15.3087 16.9756 16.21L16.9316 16.3926L16.4902 18.5977C16.4435 18.8314 16.2383 19 16 19C15.7617 19 15.5565 18.8314 15.5098 18.5977L15.0684 16.3926C14.8704 15.4029 14.0971 14.6296 13.1074 14.4316L10.9023 13.9902C10.6686 13.9435 10.5 13.7383 10.5 13.5C10.5 13.2617 10.6686 13.0565 10.9023 13.0098L13.1074 12.5684C14.0971 12.3704 14.8704 11.5971 15.0684 10.6074L15.5098 8.40234L15.5342 8.31738C15.6081 8.12866 15.7915 8 16 8ZM16 11.0098C15.679 12.2275 14.7275 13.179 13.5098 13.5C14.7272 13.8209 15.6788 14.772 16 15.9893C16.3211 14.7723 17.2723 13.8211 18.4893 13.5C17.272 13.1788 16.3209 12.2272 16 11.0098Z"
      fill="white"
    />
  </svg>
)
